import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import CallReceivedOutlinedIcon from '@mui/icons-material/CallReceivedOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import type { SvgIconComponent } from '@mui/icons-material';

export type BadgeKey = 'approvals' | 'kyc' | 'payments' | 'applications' | 'changes';

export interface NavItem {
  to: string;
  label: string;
  icon: SvgIconComponent;
  badge?: BadgeKey;
  exact?: boolean;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const MANAGER_NAV: NavGroup[] = [
  {
    label: 'Overview',
    items: [{ to: '/manager', label: 'Dashboard', icon: DashboardOutlinedIcon, exact: true }],
  },
  {
    label: 'Register',
    items: [
      { to: '/manager/funds', label: 'Funds & classes', icon: AccountBalanceWalletOutlinedIcon },
      { to: '/manager/register', label: 'Register', icon: ViewListOutlinedIcon },
      { to: '/manager/holders', label: 'Holders', icon: PeopleAltOutlinedIcon },
    ],
  },
  {
    label: 'Onboarding',
    items: [
      { to: '/manager/allocations', label: 'Allocations', icon: PieChartOutlineOutlinedIcon },
      { to: '/manager/offers', label: 'Offers', icon: StorefrontOutlinedIcon },
      {
        to: '/manager/applications',
        label: 'Applications',
        icon: HowToRegOutlinedIcon,
        badge: 'applications',
      },
      { to: '/manager/kyc', label: 'KYC & AML', icon: FactCheckOutlinedIcon, badge: 'kyc' },
    ],
  },
  {
    label: 'Money',
    items: [
      { to: '/manager/calls', label: 'Capital calls', icon: CallReceivedOutlinedIcon },
      { to: '/manager/distributions', label: 'Distributions', icon: CallMadeOutlinedIcon },
      {
        to: '/manager/capital-returns',
        label: 'Capital returns',
        icon: KeyboardReturnOutlinedIcon,
      },
      { to: '/manager/redemptions', label: 'Redemptions', icon: LogoutOutlinedIcon },
      {
        to: '/manager/payments',
        label: 'Payments & bank',
        icon: ReceiptLongOutlinedIcon,
        badge: 'payments',
      },
    ],
  },
  {
    label: 'Control',
    items: [
      {
        to: '/manager/approvals',
        label: 'Approvals',
        icon: AssignmentTurnedInOutlinedIcon,
        badge: 'approvals',
      },
      {
        to: '/manager/changes',
        label: 'Transfers & changes',
        icon: SwapHorizOutlinedIcon,
        badge: 'changes',
      },
    ],
  },
  {
    label: 'Reporting',
    items: [
      { to: '/manager/tax', label: 'Tax & ATO', icon: GavelOutlinedIcon },
      { to: '/manager/communications', label: 'Communications', icon: CampaignOutlinedIcon },
      { to: '/manager/reports', label: 'Reports', icon: AssessmentOutlinedIcon },
      { to: '/manager/exports', label: 'Accounting exports', icon: AccountBalanceOutlinedIcon },
      { to: '/manager/audit', label: 'Ledger & audit', icon: HistoryOutlinedIcon },
    ],
  },
  {
    label: 'Setup',
    items: [
      { to: '/manager/setup', label: 'Establish fund', icon: RocketLaunchOutlinedIcon },
      { to: '/manager/migration', label: 'Migration', icon: CloudUploadOutlinedIcon },
      { to: '/manager/settings', label: 'Default Values', icon: SettingsOutlinedIcon },
    ],
  },
];
